import React from 'react';
import styled from '@emotion/styled';
import BlankButton from '../../Buttons/BlankButton';
import Close from '../../../../assets/svg/Close';
import { DEFAULT_GUTTER_WIDTH } from './ModalContainers';

const CloseContainer = styled.div`
  display: flex;
  left: 0;
  position: absolute;
  justify-content: flex-end;
  padding: ${DEFAULT_GUTTER_WIDTH} ${DEFAULT_GUTTER_WIDTH} 0;
  top: 0;
  width: 100%;
  z-index: 5;
`;

const MobileModalCloseContainer = styled(CloseContainer)`
  position: fixed;
`;

export default function ModalCloseContainer(props) {
  const { closeCallback, isMobile } = props;
  // Can't use a simple variable or else it creates an element with the same name as the variable
  let closeComponent = {
    container: isMobile ? MobileModalCloseContainer : CloseContainer,
  };

  return (
    <closeComponent.container>
      <BlankButton onClick={closeCallback}>
        <Close />
      </BlankButton>
    </closeComponent.container>
  );
}
